import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import ConfirmPopup from '../components/ConfirmPopup.js';

const renderPrice = (value) => `${value}`;

export default function Eshop({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [data_history, setDataHistory] = useState([]);
	const [data_history_totals, setDataHistoryTotals] = useState(0);
	const [topay_totals, setTopayTotals] = useState('0,00');
	const [data_tmp, setDataTmp] = useState([]);
	const [data_tmp_totals, setDataTmpTotals] = useState(0);
	const [showInfoPopup, setShowInfoPopup] = useState(false);
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);
	const [data_item, setDataItem] = useState([]);
	const [offset, setOffset] = useState(0);
	const [loadedCnt, setLoadedCnt] = useState(0);

	useEffect(() => {
		getData('', offset);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const loadNext = () => {
		setOffset((prevOffset) => {
			let newOffset = prevOffset + usrInfo.LIST_ROWS;
			getData('', prevOffset + usrInfo.LIST_ROWS);
			return newOffset;
		});
	};

	const getData = (search, offset) => {
		setLoading(true);

		post('getListEshop', {search: search, offset: offset})
			.then((res) => {
				if (offset === 0) {
					setData(res.data.data);
				} else {
					setData((prevRows) => {
						const updatedRows = [...data, ...res.data.data];
						return updatedRows;
					});
				}

				setLoadedCnt(res.data.data.length);

				setDataItem(res.data.data_item);
				setDataHistory(res.data.data_history);
				setDataHistoryTotals(res.data.data_history_totals);
				setTopayTotals(res.data.topay_totals);
				setDataTmp(res.data.data_tmp);
				setDataTmpTotals(res.data.data_tmp_totals);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const deleteItemTmp = (item) => {
		setLoading(true);

		post('deleteEshopItemTmp', {ID: item.ID})
			.then((res) => {
				setDataTmp(res.data.data_tmp);
				setDataTmpTotals(res.data.data_tmp_totals);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const showInfo = () => {
		setShowInfoPopup(true);
	};

	const closeInfoPopup = () => {
		setShowInfoPopup(false);
	};

	const showConfirm = () => {
		setShowConfirmPopup(true);
	};

	const closeConfirmPopup = () => {
		setShowConfirmPopup(false);
	};

	const confirmConfirmPopup = () => {
		setLoading(true);

		post('confirmEshop', {})
			.then((res) => {
				setLoading(false);

				setShowConfirmPopup(false);

				getData('', 0);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const addItem = (item) => {
		setLoading(true);

		post('addEshopItem', {ID: item.ID})
			.then((res) => {
				setDataTmp(res.data.data_tmp);
				setDataTmpTotals(res.data.data_tmp_totals);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const list_items = data_item?.map((item, index) => {
		return (
			<button type="button" className="eshop-page__item-card" key={'item_' + index} onClick={() => addItem(item)}>
				<div className="eshop-page__item-image-wrap">
					<img className="eshop-page__item-image" src={item.IMG} alt="" />
				</div>
				<div className="eshop-page__item-name">{item.NAME}</div>
				<div className="eshop-page__item-price">{renderPrice(item.PRICES)}</div>
			</button>
		);
	});

	let cnt_tmp = 0;

	const list_tmp = data_tmp?.map((item, index) => {
		++cnt_tmp;

		return (
			<div className="eshop-page__cart-row" key={'item_' + index}>
				<div className="eshop-page__cart-item">
					<div className="eshop-page__cart-image-wrap">
						<img className="eshop-page__cart-image" src={item.IMG} alt="" />
					</div>
					<div className="eshop-page__cart-name">{cnt_tmp}. {item.NAME}</div>
				</div>
				<div className="eshop-page__cart-meta">
					<div className="eshop-page__cart-price">{renderPrice(item.PRICES)}</div>
					<button type="button" className="eshop-page__icon-button" onClick={() => deleteItemTmp(item)}>
						<img className="icon1 del small" alt="" />
					</button>
				</div>
			</div>
		);
	});

	let list_history = [];
	let oldItem = [];
	let cnt = 0;
	let pList = [];

	data_history?.forEach((item, index) => {
		++cnt;
		if (cnt === 1) {
			oldItem.ITEMID = item.ITEMID;
		}

		if (oldItem.ITEMID !== item.ITEMID) {
			list_history.push(
				<div className="eshop-page__history-group" key={'item_' + index}>
					<div className="eshop-page__history-summary">
						<div className="eshop-page__history-title">{oldItem.NAME}</div>
						<div className="eshop-page__history-lines">{pList}</div>
					</div>
				</div>
			);

			pList = [];
		}

		pList.push(
			<div className="eshop-page__history-line" key={'item_sub_' + index}>
				<div className="eshop-page__history-qty">
					{item.CNT} x {renderPrice(item.PRICES)}
				</div>
				<div className="eshop-page__history-total">{renderPrice(item.PRICE_TOTALS)}</div>
			</div>
		);

		if (cnt === data_history.length) {
			list_history.push(
				<div className="eshop-page__history-group" key={'item_' + data_history.length}>
					<div className="eshop-page__history-summary">
						<div className="eshop-page__history-title">{item.NAME}</div>
						<div className="eshop-page__history-lines">{pList}</div>
					</div>
				</div>
			);
		}

		oldItem = item;
	});

	const list = data?.map((item, index) => {
		return (
			<div className="eshop-page__ledger-row" key={'item_' + index}>
				<div className="eshop-page__row-icon">{item.IMG ? <img src={item.IMG} alt="" /> : null}</div>
				<div className="eshop-page__ledger-meta">
					<div className="eshop-page__ledger-name">{item.NAME}</div>
					<div className="eshop-page__ledger-date">{item.CRDTS}</div>
				</div>
				<div className="eshop-page__ledger-value">{renderPrice(item.PRICE)}</div>
			</div>
		);
	});

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search>
					<span className="fnt_16">
						Zbývá zaplatit:{' '}
						<span className="fnt_orange fnt_2">
							<b>{topay_totals}</b>
						</span>
					</span>
				</Search>
				<ConfirmPopup
					showConfirmPopup={showInfoPopup}
					closeConfirmPopup={closeInfoPopup}
					infoHeader="Jak to funguje"
					infoMain="Především děkujeme za vaši poctivost že přidáte a zaplatíte vše co zkonzumujete. Také se k zařízením chovejte ohleduplně a provádějte nutnou údržbu pokud to vyžaduje (vysypání lógru, vylití odkapané vody a doplnění vody).<br /><br />Použíté nádobí prosím po sobě umyjte a dejte na púvodní místo.<br /><br />Kliknutím na příslušnou položku ji přídáte do nákupního košíku. Pokud omylem přidáte nechtěnou položku tak je možné ji z košíku odstranit křížkem. Nákup potvrdíte tlačítkem 'Potvrdit nákup'.<br /><br />Částku prosím zaplaťte převodem na účet (ikonka platební karty v horní liště). Po připsání částky na účet bude váš nákup srovnán.<br /><br />Nezaplacenou částku uvidíte jako zprávu na úvodní stránce rezervací. Veškeré vaše nákupy lze vidět v historii nákupů."
				/>
				<ConfirmPopup showConfirmPopup={showConfirmPopup} showButtonConfirm cofirmConfirmPopup={confirmConfirmPopup} closeConfirmPopup={closeConfirmPopup} infoHeader="Potvrzení nákupu" infoMain="Opravdu provést nákup?<br /><br />Po potvrzení nákupu je možné částku zaplatit ihned převodem na účet pomocí QR kódu (ikonka platební karty) nebo později po více nákupech.<br /><br />Dlužná částka bude srovnána po přijetí platby." />

				<div className={`page eshop-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="eshop-page__shell">
						<section className="eshop-page__section">
							<div className="eshop-page__section-head">
								<h2 className="eshop-page__section-title">Nabídka</h2>
							</div>
							<div className="eshop-page__catalog-grid">{list_items}</div>
						</section>

						<section className="eshop-page__section">
							<div className="eshop-page__section-head">
								<h2 className="eshop-page__section-title">Nákupní košík</h2>
							</div>
							<div className="eshop-page__cart-list">
								{list_tmp.length > 0 ? list_tmp : <div className="eshop-page__empty">Košík je zatím prázdný.</div>}
							</div>
							<div className="eshop-page__total-row eshop-page__total-row--accent" key={'data_bin_totals'}>
								<div className="eshop-page__total-label">CELKEM:</div>
								<div className="eshop-page__total-value">{renderPrice(data_tmp_totals)}</div>
							</div>
							<div className="eshop-page__actions">
								<button type="button" className="button eshop-page__button" onClick={() => showInfo()}>
									Jak to funguje
								</button>

								{list_tmp.length > 0 ? (
									<button type="button" className="button green eshop-page__button" onClick={() => showConfirm()}>
										Potvrdit nákup
									</button>
								) : (
									<button type="button" className="button green eshop-page__button" disabled>
										Potvrdit nákup
									</button>
								)}
							</div>
						</section>

						<section className="eshop-page__section">
							<div className="eshop-page__section-head">
								<h2 className="eshop-page__section-title">Historie nákupů</h2>
							</div>
							<div className="eshop-page__history-list">
								{list_history.length > 0 ? list_history : <div className="eshop-page__empty">Historie nákupů je zatím prázdná.</div>}
							</div>
							<div className="eshop-page__total-row" key={'data_history_totals'}>
								<div className="eshop-page__total-label">CELKEM:</div>
								<div className="eshop-page__total-value">{renderPrice(data_history_totals)}</div>
							</div>
						</section>

						<section className="eshop-page__section">
							<div className="eshop-page__section-head">
								<h2 className="eshop-page__section-title">Přehled záznamů</h2>
							</div>
							<div className="eshop-page__ledger-list">{list.length > 0 ? list : <div className="eshop-page__empty">Přehled záznamů je zatím prázdný.</div>}</div>

							<div className="eshop-page__load-more">
								{parseInt(loadedCnt) === parseInt(usrInfo.LIST_ROWS) ? (
									<button type="button" className="button small loadNext eshop-page__button" onClick={() => loadNext()}>
										Načíst další
									</button>
								) : (
									<span className="fnt_12 loadNext eshop-page__load-all">Byly načteny všechny záznamy</span>
								)}
							</div>
						</section>
					</div>
				</div>
			</div>
		</>
	);
}
